import React from "react";
import NothingHere from "../../../../../../../assets/Illustrations/NothingHere.svg";
import { ViewFormsItem } from "./view-forms-item";
import PropTypes from "prop-types";

export const ViewForms = ({ setSelectedForm, allForms }) => {
  return (
    <div className="view-forms-content">
      {allForms?.data?.length > 0 && (
        <div className="view-forms-list">
          <div className="view-forms-list-head">Forms</div>
          <div className="view-forms-list-content">
            {allForms.data?.map((form) => (
              <ViewFormsItem
                key={form.Id}
                setSelectedForm={setSelectedForm}
                form={form}
              />
            ))}
          </div>
        </div>
      )}
      {(!allForms?.data || allForms?.data?.length === 0) && (
        <div className="view-forms-no-form">
          <img
            className="view-forms-no-form-image"
            src={NothingHere}
            alt={"NothingHere"}
          ></img>
          <div className="view-forms-no-form-head">Create your first Form</div>
          <div className="view-forms-no-form-foot">
            To get started, go to the Form Design section and click the "Add New
            Form" button.
          </div>
        </div>
      )}
    </div>
  );
};

ViewForms.propTypes = {
  setSelectedForm: PropTypes.func,
  allForms: PropTypes.object,
};